import { Box, Dialog, Portal } from '@chakra-ui/react';
import { useCreateBankAccount } from 'hooks';
import { useTranslation } from 'localization';
import { AccountFields } from 'types';

import {
  ServiceDialogBody,
  ServiceDialogCloseTrigger,
  ServiceDialogHeader,
  serviceDialogShellProps,
} from '../ServiceDialog';

import { BankAccountForm } from './components';

type PayloadType = Record<string, string | number> & { title: string };

type AddBankAccountType = {
  wallet: string;
  transactionMethod: string;
  onClose: () => void;
  onSuccess: () => void;
  isOpen: boolean;
  accountFields: AccountFields[];
};

const AddBankAccount: React.FC<AddBankAccountType> = ({
  wallet,
  onClose,
  onSuccess,
  isOpen,
  transactionMethod,
  accountFields,
}: AddBankAccountType) => {
  const { t } = useTranslation('component.deposit.initModal');

  const { mutateAsync: submit, isPending: submitLoading } =
    useCreateBankAccount();

  const onSubmit = async (data: PayloadType) => {
    submit({
      wallet,
      transaction_method: transactionMethod,
      title: data.title,
      fields: data,
    }).then(() => {
      onSuccess();
      onClose();
    });
  };

  return (
    <Box>
      <Dialog.Root
        size="xl"
        open={isOpen}
        placement="center"
        onOpenChange={(e: { open: boolean }) => {
          if (!e.open) {
            onClose();
          }
        }}
      >
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content {...serviceDialogShellProps({ maxW: 'xl' })} px={0}>
              <ServiceDialogHeader>{t('modalTitle')}</ServiceDialogHeader>
              <ServiceDialogCloseTrigger />
              <ServiceDialogBody px={0} py={4}>
                <BankAccountForm
                  onSubmit={onSubmit}
                  loading={submitLoading}
                  accountFields={accountFields}
                />
              </ServiceDialogBody>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </Box>
  );
};

export default AddBankAccount;
